import Swiper from 'swiper/bundle';

/* Creates an infinite marquee animation for a Swiper wrapper and exposes pause/resume */
const createMarquee = (rootEl, { pxPerSecond = 70 } = {}) => {
  const wrapper = rootEl.querySelector('.swiper-wrapper');
  if (!wrapper) return null;

  const originalSlides = Array.from(wrapper.children);
  if (!originalSlides.length) return null;

  const ensureFill = () => {
    wrapper.querySelectorAll('[data-marquee-clone="1"]').forEach((n) => n.remove());

    const rootWidth = rootEl.getBoundingClientRect().width;
    let total = wrapper.scrollWidth;

    while (total < rootWidth * 2) {
      originalSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.setAttribute('data-marquee-clone', '1');
        wrapper.appendChild(clone);
      });
      total = wrapper.scrollWidth;
    }

    const distance = total / 2;
    return distance;
  };

  let anim = null;

  const start = () => {
    const distance = ensureFill();
    if (!distance) return;

    anim?.cancel?.();

    const duration = Math.max(1, (distance / pxPerSecond) * 1000);

    anim = wrapper.animate(
      [
        { transform: 'translate3d(0, 0, 0)' },
        { transform: `translate3d(${-distance}px, 0, 0)` },
      ],
      { duration, iterations: Infinity, easing: 'linear' }
    );
  };

  const pause = () => anim?.pause?.();
  const resume = () => anim?.play?.();

  const destroy = () => {
    anim?.cancel?.();
    anim = null;
    wrapper.querySelectorAll('[data-marquee-clone="1"]').forEach((n) => n.remove());
  };

  return { start, pause, resume, destroy };
};

const BrandsSlider = () => {
  const sliders = [...document.querySelectorAll('.hero__brands-slider.slider-mode')];
  if (!sliders.length) return;

  const isRTL = document.documentElement.dir === 'rtl';

  sliders.forEach((el) => {
    const swiper = new Swiper(el, {
      slidesPerView: 'auto',
      loop: false,
      centeredSlides: true,
      rtl: isRTL,
      allowTouchMove: false,
       spaceBetween: 32,
    breakpoints: {
      768: {
        spaceBetween: 48,
      },
    }
    });

    const marquee = createMarquee(el, { pxPerSecond: 70 });
    marquee?.start?.();

    el.addEventListener('mouseenter', () => marquee?.pause?.());
    el.addEventListener('mouseleave', () => marquee?.resume?.());

    window.addEventListener('resize', () => marquee?.start?.(), { passive: true });
  });
};

export default BrandsSlider;
